const DEBUG_AB_TEST_PARAM_NAME = "debug-ab-test-name";
// AB TESTS
const BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES = {
    test_name: "homepage_bigger_storage_in_pricing_page_features",
    new_variation_name: "new_with_bigger_storage"
};
const HOMEPAGE_V10_PRICING_VERSION_AB_TEST = {
    test_name: "homepage_v10_pricing_version_ab_test",
    new_variation_name: "new_with_v10"
};
const HOMEPAGE_FREE_TIER_2022_ABC_TEST = {
    test_name: "homepage_free_tier_2022_ab_test",
    new_variation_name_b: "new_with_free_tier_2022_a",
    new_variation_name_c: "new_with_free_tier_2022_b"
};
const HOMEPAGE_HIDE_BASIC_AB_TEST = {
    test_name: "homepage_hide_basic_ab_test",
    new_variation_name: "new_with_hide_basic"
};
const NEW_CRM_PRICING_TEST = {
    test_name: "new_crm_pricing_test",
    variant_a: "new_crm_pricing"
};
const CRM_PRICING_NO_BASIC_TEST = {
    test_name: "crm_pricing_no_basic_test",
    variant_a: "new_crm_pricing_no_basic"
};
const CRM_PRICING_NO_SEATS_TEST = {
    test_name: "crm_pricing_no_seats_test",
    new_variation_name: "new_crm_pricing_no_seats"
};
const HOMEPAGE_GOOGLE_ONE_TAP_TEST = {
    test_name: "homepage_google_one_tap_test",
    new_variation_name: "new_with_google_one_tap"
};
const CREDITS_PER_SEAT_HOMEPAGE_AB_TEST = {
    test_name: "credits_per_seat_homepgae_ab_test",
    new_variation_name: "new_with_credits_per_seat_homepgae_ab_test"
};
const BASE_FORM_WHAT_TO_ACHIEVE_TEST = {
    test_name: "base_form_what_to_achieve_test",
    new_variation_name: "new_with_what_to_achieve"
};
module.exports = {
    DEBUG_AB_TEST_PARAM_NAME,
    BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES,
    HOMEPAGE_V10_PRICING_VERSION_AB_TEST,
    HOMEPAGE_FREE_TIER_2022_ABC_TEST,
    HOMEPAGE_HIDE_BASIC_AB_TEST,
    NEW_CRM_PRICING_TEST,
    CRM_PRICING_NO_BASIC_TEST,
    CRM_PRICING_NO_SEATS_TEST,
    HOMEPAGE_GOOGLE_ONE_TAP_TEST,
    CREDITS_PER_SEAT_HOMEPAGE_AB_TEST,
    BASE_FORM_WHAT_TO_ACHIEVE_TEST
};
